import Utility from '@/helper/Utility.js';
import CacheHelper from '@/helper/CacheHelper';
import DatetimeHelper from '@/helper/DatetimeHelper';
import { DateTime } from 'luxon';
//#region register model
export const RegisterModel = function () {
    this.questionnaireId = null
    this.prefix = null
    this.fullName = null
    this.contactNumber = '';

    this.lineDisplayName = ""
    this.lineUserId = null;

    this.nationalId = null
    this.birthDay = null

    this.loadCache()
}

RegisterModel.prototype.getParams = function () {
    // send date as ISO-8601
    let jsDate = DatetimeHelper.unixTimestampToDate(this.birthDay)
    let luxonDate = DateTime.fromJSDate(jsDate)
    let params = {
        questionnaire_id: this.questionnaireId,
        display_name: this.lineDisplayName,
        user_mid: this.lineUserId,
        answers: {
            first_name: this.fullName,
            thai_citizen_id: this.nationalId,
            phone_number: this.contactNumber,
            date_of_birth: luxonDate.toISODate()
        }
    }

    return JSON.stringify(Utility.cleanObjectEmptyStr(params));
}

RegisterModel.prototype.setLineData = function (profile) {
    this.lineUserId = profile.userId;
    this.lineDisplayName = profile.displayName
}

RegisterModel.prototype.setLineDataFromCookie = function () {
    let cacheHelper = new CacheHelper()

    let lineUserId = cacheHelper.getCache("line_user_id") ?? null
    let lineDisplayName = cacheHelper.getCache("line_displayname") ?? null

    this.lineUserId = lineUserId;
    this.lineDisplayName = lineDisplayName
}

RegisterModel.prototype.setQuestionarieId = function (id) {
    this.questionnaireId = id
}

RegisterModel.prototype.saveCache = function () {
    let json = JSON.stringify(this)
    sessionStorage.setItem("ttb-register.model", json)

    return this
}

RegisterModel.prototype.loadCache = function () {
    let raw = sessionStorage.getItem("ttb-register.model")
    if (!Utility.isEmptyStr(raw)) {
        let json = JSON.parse(raw)
        Object.keys(json).forEach((key) => {
            this[key] = json?.[key]
        })
    }

    return this
}

//#endregion register model

export const RegisterResponse = function (res) {
    this.res = res;

    this.getTraceplanPoint = function (traceplanId) {
        if (this.res?.buzzebees == null) {
            return 0;
        }
        let list = res.buzzebees.traces;
        let trace = list.find((item) => {
            let id = this.getTraceId(item);
            return id == traceplanId;
        });

        if (trace != null) {
            return trace.Points;
        }
        return 0;
    };

    this.getTraceId = function (trace) {
        let id1 = trace.id;
        let id2 = trace.Id;
        let id3 = trace.ID;

        if (id1 != null) {
            return id1;
        } else if (id2 != null) {
            return id2;
        } else if (id3 != null) {
            return id3;
        } else {
            return null;
        }
    };
}
